/*
   The detector settings this deployment offers, with their labels.
*/

import { queryOptions } from "@tanstack/react-query"

import { http } from "@/lib/http"
import { qk } from "@/lib/query-keys"

import { parseDetectorProfileOptions } from "./profile"

/**
 * `GET /detector-profile/options`: the keys, their values, a label and a line
 * of help for each, and what Automatic falls back to here.
 *
 * Shared by the intake, the workspace, the report, the Clients screen and the
 * evaluation runs, which is why it lives with the domain components rather
 * than in one slice. Changes only with a deploy, so it is cached for the
 * session.
 */
export const detectorProfileOptionsQuery = (enabled = true) =>
  queryOptions({
    queryKey: qk.detectorProfile.options(),
    queryFn: async ({ signal }) =>
      parseDetectorProfileOptions(
        await http.get<unknown>("/api/v1/detector-profile/options", { signal }),
      ),
    enabled,
    staleTime: Infinity,
  })
